'use client';

import { c as _c } from "react/compiler-runtime";
import { useLocale } from 'next-intl';
import { useUserContext } from '@module/mdrt-org/shared/components/providers/user-context';
import { AccountSettingsFormSection } from '@module/mdrt-org/shared/utils/enums/account-settings-form-section';
import { SocialPlatform } from '@module/mdrt-org/shared/utils/enums/social-platform';
import { loginHandler } from '@module/mdrt-org/shared/utils/helpers/login-handler';
import { useAdB2cObjectId } from '@module/mdrt-org/shared/utils/hooks/use-ad-b2c-object-id';
import { AuthProviderName } from '@shared/misc/next-auth/enum';
import { type ParsedToken, parseJwtToken } from '@shared/misc/utils/parse-jwt-token';
import { CheckboxInput } from '@shared/ui-components/checkbox-input/checkbox-input';
import { type AccountSettingsLoginPasswordContent } from '../get-account-settings-login-password-content';
import styles from './social-logins.module.scss';
const platformUrls = {
  [SocialPlatform.Apple]: 'https://appleid.apple.com',
  [SocialPlatform.Facebook]: 'facebook.com',
  [SocialPlatform.Google]: 'google.com',
  [SocialPlatform.LinkedIn]: 'linkedin.com'
};
const isSocialLoginEnabled = (parsedToken: ParsedToken | undefined, platform: SocialPlatform) => parsedToken?.alternativeSecurityIds?.some(id => id.identityProvider === platformUrls[platform]) || false;
export const SocialLogins = t0 => {
  const $ = _c(29);
  const {
    cmsContent
  } = t0;
  const locale = useLocale();
  const {
    accessToken
  } = useUserContext();
  const userId = useAdB2cObjectId();
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== accessToken || $[1] !== cmsContent.appleLabel || $[2] !== cmsContent.approvedSocialLogins || $[3] !== cmsContent.browserPermissionInformation || $[4] !== cmsContent.facebookLabel || $[5] !== cmsContent.googleLabel || $[6] !== cmsContent.linkedInLabel || $[7] !== cmsContent.pagePaths || $[8] !== locale || $[9] !== userId) {
    const parsedToken = accessToken ? parseJwtToken(accessToken) : undefined;
    const socialLoginsData = [{
      id: "google",
      label: cmsContent.googleLabel,
      socialPlatform: SocialPlatform.Google
    }, {
      id: "apple",
      label: cmsContent.appleLabel,
      socialPlatform: SocialPlatform.Apple
    }, {
      id: "facebook",
      label: cmsContent.facebookLabel,
      socialPlatform: SocialPlatform.Facebook
    }, {
      id: "linkedin",
      label: cmsContent.linkedInLabel,
      socialPlatform: SocialPlatform.LinkedIn
    }].map(platformData => ({
      ...platformData,
      value: isSocialLoginEnabled(parsedToken, platformData.socialPlatform)
    }));
    const handleSwitchChange = platform => {
      const isChecked = isSocialLoginEnabled(parsedToken, platform);
      const authProvider = isChecked ? AuthProviderName.RemoveSocialSignIn : AuthProviderName.SocialSignIn;
      const authorizationParameters = {
        ui_locales: locale,
        userId,
        ...(isChecked && {
          provider: platformUrls[platform]
        })
      };
      loginHandler({
        authorizationParameters,
        options: {
          redirectTo: `${cmsContent.pagePaths.accountSettingPagePath}#${AccountSettingsFormSection.LoginPassword}`
        },
        provider: authProvider
      });
    };
    t5 = styles["social-logins-form"];
    if ($[15] !== cmsContent.approvedSocialLogins) {
      t4 = <h2 className={styles["social-logins-form__heading"]}>{cmsContent.approvedSocialLogins}</h2>;
      $[15] = cmsContent.approvedSocialLogins;
      $[16] = t4;
    } else {
      t4 = $[16];
    }
    t1 = styles["social-logins-form__fieldset"];
    if ($[17] !== cmsContent.browserPermissionInformation) {
      t2 = <legend className={styles["social-logins-form__legend"]}>{cmsContent.browserPermissionInformation}</legend>;
      $[17] = cmsContent.browserPermissionInformation;
      $[18] = t2;
    } else {
      t2 = $[18];
    }
    t3 = socialLoginsData.map(socialLoginElement => <CheckboxInput id={socialLoginElement.id} isChecked={socialLoginElement.value} isSwitch={true} key={socialLoginElement.id} label={socialLoginElement.label} onChange={() => handleSwitchChange(socialLoginElement.socialPlatform)} />);
    $[0] = accessToken;
    $[1] = cmsContent.appleLabel;
    $[2] = cmsContent.approvedSocialLogins;
    $[3] = cmsContent.browserPermissionInformation;
    $[4] = cmsContent.facebookLabel;
    $[5] = cmsContent.googleLabel;
    $[6] = cmsContent.linkedInLabel;
    $[7] = cmsContent.pagePaths;
    $[8] = locale;
    $[9] = userId;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t1 = $[10];
    t2 = $[11];
    t3 = $[12];
    t4 = $[13];
    t5 = $[14];
  }
  let t6;
  if ($[19] !== t1 || $[20] !== t2 || $[21] !== t3) {
    t6 = <fieldset className={t1}>{t2}{t3}</fieldset>;
    $[19] = t1;
    $[20] = t2;
    $[21] = t3;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== t4 || $[24] !== t6) {
    t7 = <div>{t4}{t6}</div>;
    $[23] = t4;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] !== t5 || $[27] !== t7) {
    t8 = <form className={t5}>{t7}</form>;
    $[26] = t5;
    $[27] = t7;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  return t8;
};